<div class="d-flex align-content-center justify-content-center">
  {{message | translate}}
</div>